var map = {
	"./BCH-icon.svg": 458,
	"./BTC-icon.svg": 459,
	"./ETC-icon.svg": 460,
	"./ETH-icon.svg": 461,
	"./LTC-icon.svg": 462,
	"./USDT-icon.svg": 463,
	"./XRP-icon.svg": 464,
	"./cookie-icon.svg": 252,
	"./default-avatar-icon.svg": 465,
	"./deposit-icon.svg": 245,
	"./history-icon.svg": 247,
	"./home-icon.svg": 249,
	"./oero-icon.svg": 148,
	"./settings-icon.svg": 248,
	"./support-icon.svg": 253,
	"./tooltip-icon.svg": 254,
	"./withdraw-icon.svg": 246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 457;